import { DistanceServices } from './distance_services';
import { MapSearch } from './map_search';

class TextSearchingEngine {
  MAX_LOCATION_DISTANCE = 10; // miles

  constructor(mapSearch, showCallback, hideCallback, googleService, placeService, sessionToken) {
    this.mapSearch = mapSearch;
    this.locations = mapSearch.locations;
    this.showCallback = showCallback;
    this.hideCallback = hideCallback;
    this.googleService = googleService;
    this.placeService = placeService;
    this.sessionToken = sessionToken;
    this.mapSearch.synchronizeWith(this);
  }

  call(filters) {
    const searchedText = document.getElementById('search').value;
    const foundLocations = this.suitableBikeLinkLocations(searchedText);
    if (foundLocations) {
      this.simpleListSearching(filters, searchedText);
    } else {
      this.googleSearchingLocations(filters, searchedText);
    }
  }

  simpleListSearching(filters, searchedText) {
    this.locations.forEach((location) => {
      if (this.mapSearch.runChecking(filters, location) && MapSearch.searching(location, searchedText)) {
        this.showCallback(location.id);
      } else {
        this.hideCallback(location.id);
      }
    });
  }

  suitableBikeLinkLocations(searchedText) {
    return this.locations.some((location) => {
      return MapSearch.searching(location, searchedText);
    });
  }

  googleSearchingLocations(filters, searchedText) {
    const googleParams = {
      input: searchedText,
      sessionToken: this.sessionToken,
      componentRestrictions: { country: 'us' }
    };
    this.googleService.getPlacePredictions(googleParams, (predictions, status) => {
      if (status !== google.maps.places.PlacesServiceStatus.OK) {
        return;
      }
      this.placeService.getDetails(
        { placeId: predictions[0].place_id, fields: ['geometry'] },
        (place, status) => {
          if (status !== google.maps.places.PlacesServiceStatus.OK) {
            return;
          }
          this.filterLocationsBasedOnDistance(filters, place.geometry.location);
        }
      );
    });
  }

  filterLocationsBasedOnDistance(filters, position) {
    let bestResult = null;
    let foundAtLeastOneResult = false;
    this.locations.forEach((location) => {
      const distance = DistanceServices.distanceInBetweenGPSCoordinates(
        { latitude: location.latitude, longitude: location.longitude },
        { latitude: position.lat(), longitude: position.lng() }
      );
      const notFiltered = this.mapSearch.runChecking(filters, location);
      if ((distance <= this.MAX_LOCATION_DISTANCE) && notFiltered) {
        this.showCallback(location.id);
        foundAtLeastOneResult = true;
      } else {
        this.hideCallback(location.id);
        if (((bestResult === null) || (bestResult.distance > distance)) && notFiltered) {
          bestResult = { location_id: location.id, distance };
        }
      }
    });
    if ((bestResult !== null) && !foundAtLeastOneResult) {
      this.showCallback(bestResult.location_id);
    }
  }
}

class MapList {

  constructor(element, locations) {
    this.moveToExactLocation = this.moveToExactLocation.bind(this);
    this.moveToPlaceLocation = this.moveToPlaceLocation.bind(this);
    this.hide = this.hide.bind(this);
    this.show = this.show.bind(this);
    this.element = element;
    this.locations = locations;
    this.locationElements = this.loadLocations();
    this.googleService = new google.maps.places.AutocompleteService();
    this.placeService = new google.maps.places.PlacesService(document.createElement('div'));
    this.sessionToken = new google.maps.places.AutocompleteSessionToken();
    this.mapSearch = new MapSearch(this.locations, 'list');
    this.textSearchEngine = new TextSearchingEngine(
      this.mapSearch,
      this.show,
      this.hide,
      this.googleService,
      this.placeService,
      this.sessionToken
    );
    this.mapSearch.activateAutoComplete(
      this.moveToExactLocation,
      this.moveToPlaceLocation,
      this.googleService,
      this.placeService,
      this.sessionToken
    );
    this.updateLocationTimer = null;
  }

  loadLocations() {
    const res = {};
    const locationElements = document.querySelectorAll('.list-wrapper li');
    locationElements.forEach((locationElement) => {
      res[locationElement.dataset.locationId] = locationElement;
    });
    return res;
  }

  updateLocationCount() {
    const visibleCount = document.querySelectorAll('.list-wrapper li:not([style*="display:none"])').length;
    const listHeader = document.querySelector('.list .list-header');
    if (listHeader) {
      listHeader.innerHTML = I18n.t('modern.maps.list.total_count', { number: visibleCount });
    }
    this.updateLocationTimer = null;
  }

  moveToExactLocation(id, latitude, longitude) {
    const searchedText = document.getElementById('search').value;
    this.textSearchEngine.simpleListSearching(this.mapSearch.prepareFilters(), searchedText);
  }

  moveToPlaceLocation(position) {
    this.textSearchEngine.filterLocationsBasedOnDistance(this.mapSearch.prepareFilters(), position);
  }

  hide(location_id) {
    if (!this.locationElements[location_id]) {
      return;
    }
    this.locationElements[location_id].style.cssText = 'display:none !important';
    if (!this.updateLocationTimer) {
      this.updateLocationTimer = setTimeout(this.updateLocationCount.bind(this), 10);
    }
  }

  show(location_id) {
    if (!this.locationElements[location_id]) {
      return;
    }
    this.locationElements[location_id].style.cssText = 'display:flex !important';
    if (!this.updateLocationTimer) {
      this.updateLocationTimer = setTimeout(this.updateLocationCount.bind(this), 10);
    }
  }
}

export { MapList };
